import React, { useState } from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import FAQSchema from '../../FAQSchema';

// Register necessary components
ChartJS.register(
  ArcElement,
  ChartTooltip,
  Legend
);

const UninonBankCarLoanEmiCalculator  = () => {
  const [loanAmount, setLoanAmount] = useState(500000);
  const [interestRate, setInterestRate] = useState(8);
  const [loanTenure, setLoanTenure] = useState(5);
  const [monthlyEMI, setMonthlyEMI] = useState(0);
  const [totalInterest, setTotalInterest] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [amortizationSchedule, setAmortizationSchedule] = useState([]);
  const [activeYear, setActiveYear] = useState(null);

  const calculateEMI = () => {
    const principal = loanAmount;
    const annualInterest = interestRate / 100;
    const monthlyInterest = annualInterest / 12;
    const tenureInMonths = loanTenure * 12;

    const emi =
      (principal * monthlyInterest * Math.pow(1 + monthlyInterest, tenureInMonths)) /
      (Math.pow(1 + monthlyInterest, tenureInMonths) - 1);

    const totalAmount = emi * tenureInMonths;
    const totalInterest = totalAmount - principal;

    setMonthlyEMI(emi.toFixed(2));
    setTotalInterest(totalInterest.toFixed(2));
    setTotalAmount(totalAmount.toFixed(2));

    const schedule = [];
    let balance = principal;
    // let currentYear = new Date().getFullYear();
    let currentYear = new Date().getFullYear();

    let currentMonth = 6;

    for (let i = 0; i < tenureInMonths; i++) {
      const interestForMonth = balance * monthlyInterest;
      const principalForMonth = emi - interestForMonth;
      balance -= principalForMonth;

      schedule.push({
        // month: i + 1,
        // year: year,
        month: (currentMonth + i) % 12 + 1, // Ensure month is in range 1-12
        year: currentYear + Math.floor((currentMonth + i) / 12),
        principalPaid: principalForMonth,
        interestPaid: interestForMonth,
        totalPayment: emi,
        balance: balance,
      });

      // if ((i + 1) % 12 === 0) {
      //   year++;
      // }
    }

    setAmortizationSchedule(schedule);
  };

  const handleLoanAmountChange = (e) => {
    const value = e.target.value;
    setLoanAmount(value === '' ? 0 : parseInt(value));
  };

  const handleInterestRateChange = (e) => {
    const value = e.target.value;
    setInterestRate(value === '' ? 0 : parseFloat(value));
  };

  const handleLoanTenureChange = (e) => {
    const value = e.target.value;
    setLoanTenure(value === '' ? 0 : parseInt(value));
  };

  const handleYearToggle = (year) => {
    setActiveYear(activeYear === year ? null : year);
  };

  const data = {
    labels: ['Principal Amount', 'Total Interest'],
    datasets: [
      {
        label: 'EMI Breakdown',
        data: [loanAmount, totalInterest],
        backgroundColor: ['#36A2EB', '#FF6384'],
      },
    ],
  };
function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  
    const [activeIndex, setActiveIndex] = useState(0);
  
     
    const faqs = [
        {
            "question": "What is the minimum EMI I can expect with Union Bank of India?",
            "answer": "It depends on your loan amount, interest rate, and tenure. With a longer tenure, your EMI can be as low as ₹2,000-₹3,000 for smaller loans."
          },
          {
            "question": "Is the Union Bank EMI calculator free?",
            "answer": "Yes, TheFinMaster’s Union Bank of India EMI Calculator is completely free to use."
          },
          {
            "question": "Can I calculate EMI for both new and used cars?",
            "answer": "Absolutely. The calculator can be used for any car loan, regardless of vehicle age."
          },
          {
            "question": "Does it consider prepayment in EMI calculation?",
            "answer": "The standard calculator doesn’t factor prepayments, but you can manually adjust the loan amount accordingly."
          },
          {
            "question": "What is the maximum loan tenure available?",
            "answer": "Union Bank offers tenures ranging from 1 year to 7 years."
          },
          {
            "question": "How accurate is the EMI shown?",
            "answer": "The EMI is a close approximation and actual figures may vary slightly based on Union Bank’s internal calculations and fees."
          },
          {
            "question": "What documents are required to apply for a car loan?",
            "answer": "Typically, ID proof, address proof, income proof, bank statements, and vehicle invoice."
          },
          {
            "question": "Is a co-applicant allowed in Union Bank car loan?",
            "answer": "Yes, you can apply jointly to enhance your eligibility."
          },
          {
            "question": "Can I negotiate the interest rate?",
            "answer": "With a strong credit profile, you may be able to negotiate a better rate with the bank."
          },
          {
            "question": "What happens if I miss an EMI?",
            "answer": "Missing an EMI can attract penalties and impact your credit score."
          },
          {
            "question": "Can I change my EMI date after loan disbursement?",
            "answer": "Some banks allow this option; it’s best to check directly with Union Bank."
          },
          {
            "question": "What is the processing fee for Union Bank car loan?",
            "answer": "It ranges between 0.25% to 1% of the loan amount, subject to a minimum and maximum cap."
          },
          {
            "question": "Is there any prepayment penalty?",
            "answer": "Union Bank may charge a small fee for prepayment, depending on the tenure and amount repaid."
          },
          {
            "question": "Will EMI remain constant for floating interest loans?",
            "answer": "No, the EMI can fluctuate based on market rates if you opt for a floating interest plan."
          },
          {
            "question": "Can I apply for Union Bank car loan online?",
            "answer": "Yes, the bank offers digital applications through their portal and affiliated platforms like TheFinMaster."
          }
        ]
    const toggleAccordion = (index) => {
      if (activeIndex === index) {
          // If the clicked question is already expanded, collapse it
          setActiveIndex(null);
      } else {
          // If the clicked question is not expanded, expand it
          setActiveIndex(index);
      };
    }
  return (
    <>
     <Helmet>
         <title>Union Bank Car Loan EMI Calculator – Accurate EMI Planning Tool</title>
        <meta  name='description' content='Estimate your car loan EMIs with the Union Bank calculator. Get a clear picture of your monthly obligations before applying.'/>
        <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/Union-car-loan-emi-calculator" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
      <ol className="list-none p-0 inline-flex">
        <li className="flex items-center">
          <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
        <li className="flex items-center">
          <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
          <li className="flex items-center">
          <span className="text-gray-500 ">Union Loan EMI Calculator</span>
        </li> 
      
      </ol>
    </nav>
        <div className='py-4'>
    <div className="container mx-auto p-4 shadow-xl rounded-md">
      <h1 className="text-2xl font-bold mb-4">Union Bank Car Loan EMI Calculator</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Amount</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                value={loanAmount}
                onChange={handleLoanAmountChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">₹ {loanAmount.toLocaleString()}</span>
            </div>
            <input
              type="range"
              min="0"
              max="10000000"
              value={loanAmount}
              onChange={(e) => setLoanAmount(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Rate of Interest (P.A.)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="100"
                step="0.1"
                value={interestRate}
                onChange={handleInterestRateChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{interestRate} %</span>
            </div>
            <input
              type="range"
              min="0"
              max="15"
              step="0.1"
              value={interestRate}
              onChange={(e) => setInterestRate(parseFloat(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Tenure (Years)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="30"
                value={loanTenure}
                onChange={handleLoanTenureChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{loanTenure} Yr</span>
            </div>
            <input
              type="range"
              min="0"
              max="30"
              value={loanTenure}
              onChange={(e) => setLoanTenure(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <button
            onClick={calculateEMI}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Calculate
          </button>
        </div>
        <div>
          <div className="mb-4">
            <h2 className="text-xl font-bold">Results</h2>
            <p>Monthly EMI: ₹ {parseFloat(monthlyEMI).toLocaleString()}</p>
            <p>Total Principal Amount: ₹ {loanAmount.toLocaleString()}</p>
            <p>Total Interest: ₹ {parseFloat(totalInterest).toLocaleString()}</p>
            <p>Total Amount (Principal + Interest): ₹ {parseFloat(totalAmount).toLocaleString()}</p>
          </div>
          <div>
            <h2 className="text-xl font-bold">Breakdown</h2>
            <div className="flex justify-center">
              <Pie data={data} options={{ maintainAspectRatio: false }} width={300} height={300} />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6">
        <h2 className="text-xl font-bold mb-4">Amortization Schedule</h2>
        {amortizationSchedule.length > 0 && (
          <div className="flex flex-col space-y-4">
            {Array.from(new Set(amortizationSchedule.map(item => item.year))).map((year, idx) => (
              <div key={idx} className="mb-4 border rounded-md shadow-md">
                <div
                  className={`cursor-pointer text-lg font-semibold bg-gray-100 p-4 flex justify-between items-center ${activeYear === year ? 'bg-blue-100' : ''}`}
                  onClick={() => handleYearToggle(year)}
                >
                  <span>{year}</span>
                  <span>{activeYear === year ? '-' : '+'}</span>
                </div>
                {activeYear === year && (
                  <div className="overflow-x-auto">
                    <table className="min-w-full bg-white rounded-md shadow-md">
                      <thead>
                        <tr>
                          <th className="py-2 px-4 border-b">Month</th>
                          <th className="py-2 px-4 border-b">Principal Paid</th>
                          <th className="py-2 px-4 border-b">Interest Charged</th>
                          <th className="py-2 px-4 border-b">Total Payment</th>
                          <th className="py-2 px-4 border-b">Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                        {amortizationSchedule.filter(item => item.year === year).map((item, idx) => (
                          <tr key={idx}>
                            <td className="py-2 px-4 border-b">{new Date(0, item.month - 1).toLocaleString('default', { month: 'short' })}</td>
                            <td className="py-2 px-4 border-b">₹ {item.principalPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.interestPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.totalPayment.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.balance.toFixed(2).toLocaleString()}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
     <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
     <div className="w-full md:w-2/3 p-4 mx-auto">
     <div className="container mx-auto py-4">
          <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            Plan Your Union Bank of India Car Loan Payments with TheFinMaster’s EMI Calculator
          </h1>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Buying your dream car becomes much easier with Union Bank of India’s tailored car loan options. Whether you're considering a new vehicle for personal use or upgrading your current one, understanding your repayment structure is crucial. TheFinMaster’s Union Bank of India Car Loan EMI Calculator helps you make informed decisions by giving a detailed insight into your monthly payments, interest outgo, and repayment schedule. This powerful tool helps you plan your finances better and choose the most suitable loan structure based on your affordability and goals.
          </p>
</div>
          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is a Car Loan EMI?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              EMI, or Equated Monthly Installment, is the fixed payment amount made by a borrower to a lender at a specified date each calendar month. A car loan EMI comprises two components:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Principal</strong> – The original loan amount borrowed.</li>
              <li><strong>Interest</strong> – The cost of borrowing, calculated on the outstanding principal.</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Over time, the interest component reduces, while the principal repayment increases. Understanding EMI helps you avoid financial strain and plan your monthly budget better.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              For example, if you borrow ₹6,00,000 from Union Bank of India at an interest rate of 9% for a tenure of 5 years, your monthly EMI will be a predictable amount that fits your budget.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is Union Bank of India Car Loan EMI Calculator?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The Union Bank of India Car Loan EMI Calculator by TheFinMaster is a robust digital tool that estimates your monthly EMI based on the following inputs:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Loan Amount</li>
              <li>Interest Rate</li>
              <li>Loan Tenure</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              It instantly calculates the EMI and gives you additional insights such as total repayment amount and total interest paid. This tool saves time, avoids manual errors, and helps you evaluate your financial commitments before applying for a car loan. Whether you're comparing multiple loan options or planning a prepayment strategy, our calculator makes the process seamless and transparent.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why Use TheFinMaster’s Union Bank of India Car Loan EMI Calculator?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using TheFinMaster’s EMI calculator for Union Bank of India car loans offers several advantages:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Time Efficiency</strong> – No need for manual calculations. Just input the values and get instant results.</li>
              <li><strong>Accuracy</strong> – Minimizes human error with algorithm-backed calculations.</li>
              <li><strong>Amortisation View</strong> – Detailed month-by-month breakdown of your loan repayment.</li>
              <li><strong>Informed Decisions</strong> – Lets you compare loan options, tenures, and EMI burdens across banks.</li>
              <li><strong>Budget Planning</strong> – Helps you align your EMIs with your monthly expenses and savings.</li>
              <li><strong>Financial Clarity</strong> – Clearly displays your interest payout and total repayment amount.</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              It’s more than just a calculator – it’s a financial planning companion tailored for your car loan journey with Union Bank of India.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does the Union Bank of India Car Loan EMI Calculator Work?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The EMI calculator uses the following standard formula:
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              EMI = [P x R x (1+R)^N] / [(1+R)^N – 1]
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Where:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>P is the principal loan amount</li>
              <li>R is the monthly interest rate (annual rate divided by 12 × 100)</li>
              <li>N is the number of monthly installments</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Example:</strong><br />
              If you take a car loan of ₹7,00,000 from Union Bank of India for 5 years at an interest rate of 9%, the calculation will look like:<br />
              Loan Amount (P) = ₹7,00,000<br />
              Interest Rate = 9% per annum = 0.75% per month (R)<br />
              Tenure (N) = 60 months<br />
              EMI = [700000 x 0.0075 x (1+0.0075)^60] / [(1+0.0075)^60 – 1]<br />
              The result is an approximate EMI of ₹14,560 per month.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is the Amortisation Schedule?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The amortisation schedule is a detailed table that breaks down each EMI payment across the entire loan tenure. It shows how much of your EMI goes toward paying off the interest and how much goes toward the principal. In the beginning, a larger share goes to interest, but as the loan matures, the principal component increases.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Sample 12-Month Amortisation Schedule (₹7,00,000, 9% p.a., 5 years)</strong>
            </p>
                {/* <div className="overflow-x-auto">
                <table className="w-full text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-4 border-collapse">
                    <thead>
                    <tr className="bg-gray-100">
                        <th className="border px-4 py-2 text-left">Month</th>
                        <th className="border px-4 py-2 text-left">EMI (₹)</th>
                        <th className="border px-4 py-2 text-left">Interest (₹)</th>
                        <th className="border px-4 py-2 text-left">Principal (₹)</th>
                        <th className="border px-4 py-2 text-left">Outstanding Balance (₹)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td className="border px-4 py-2">1</td>
                        <td className="border px-4 py-2">14,560</td>
                        <td className="border px-4 py-2">5,250</td>
                        <td className="border px-4 py-2">9,310</td>
                        <td className="border px-4 py-2">6,90,690</td>
                    </tr>
                    <tr>
                        <td className="border px-4 py-2">2</td>
                        <td className="border px-4 py-2">14,560</td>
                        <td className="border px-4 py-2">5,180</td>
                        <td className="border px-4 py-2">9,380</td>
                        <td className="border px-4 py-2">6,81,310</td>
                    </tr>
                    <tr>
                        <td className="border px-4 py-2">3</td>
                        <td className="border px-4 py-2">14,560</td>
                        <td className="border px-4 py-2">5,110</td>
                        <td className="border px-4 py-2">9,450</td>
                        <td className="border px-4 py-2">6,71,860</td>
                    </tr>
                    <tr>
                        <td className="border px-4 py-2">4</td>
                        <td className="border px-4 py-2">14,560</td>
                        <td className="border px-4 py-2">5,038</td>
                        <td className="border px-4 py-2">9,522</td>
                        <td className="border px-4 py-2">6,62,338</td>
                    </tr>
                    <tr>
                        <td className="border px-4 py-2">5</td>
                        <td className="border px-4 py-2">14,560</td>
                        <td className="border px-4 py-2">4,967</td>
                        <td className="border px-4 py-2">9,593</td>
                        <td className="border px-4 py-2">6,52,745</td>
                    </tr>
                    <tr>
                        <td className="border px-4 py-2">6</td>
                        <td className="border px-4 py-2">14,560</td>
                        <td className="border px-4 py-2">4,895</td>
                        <td className="border px-4 py-2">9,665</td>
                        <td className="border px-4 py-2">6,43,080</td>
                    </tr>
                    <tr>
                        <td className="border px-4 py-2">7</td>
                        <td className="border px-4 py-2">14,560</td>
                        <td className="border px-4 py-2">4,823</td>
                        <td className="border px-4 py-2">9,737</td>
                        <td className="border px-4 py-2">6,33,343</td>
                    </tr>
                    <tr>
                        <td className="border px-4 py-2">8</td>
                        <td className="border px-4 py-2">14,560</td>
                        <td className="border px-4 py-2">4,750</td>
                        <td className="border px-4 py-2">9,810</td>
                        <td className="border px-4 py-2">6,23,533</td>
                    </tr>
                    <tr>
                        <td className="border px-4 py-2">9</td>
                        <td className="border px-4 py-2">14,560</td>
                        <td className="border px-4 py-2">4,676</td>
                        <td className="border px-4 py-2">9,884</td>
                        <td className="border px-4 py-2">6,13,649</td>
                    </tr>
                    <tr>
                        <td className="border px-4 py-2">10</td>
                        <td className="border px-4 py-2">14,560</td>
                        <td className="border px-4 py-2">4,602</td>
                        <td className="border px-4 py-2">9,958</td>
                        <td className="border px-4 py-2">6,03,691</td>
                    </tr>
                    <tr>
                        <td className="border px-4 py-2">11</td>
                        <td className="border px-4 py-2">14,560</td>
                        <td className="border px-4 py-2">4,528</td>
                        <td className="border px-4 py-2">10,032</td>
                        <td className="border px-4 py-2">5,93,659</td>
                    </tr>
                    <tr>
                        <td className="border px-4 py-2">12</td>
                        <td className="border px-4 py-2">14,560</td>
                        <td className="border px-4 py-2">4,452</td>
                        <td className="border px-4 py-2">10,108</td>
                        <td className="border px-4 py-2">5,83,551</td>
                    </tr>
                    </tbody>
                </table>
                </div> */}
            <div className="mt-6">
  {/* Table view for medium and up */}
  <div className="hidden md:block overflow-x-auto">
    <table className="w-full text-lg text-gray-600 mt-4 border-collapse">
      <thead>
        <tr className="bg-gray-100">
          <th className="border px-4 py-2 text-left">Month</th>
          <th className="border px-4 py-2 text-left">EMI(₹)</th>
          <th className="border px-4 py-2 text-left">Interest  (₹)</th>
          <th className="border px-4 py-2 text-left">Principal  (₹)</th>
          <th className="border px-4 py-2 text-left">Outstanding Balance (₹)</th>
        </tr>
      </thead>
      <tbody>
        {[
          
       
          ["1", "₹14,560", "₹5,250", "₹9,310", "₹6,90,690"],
          ["2", "₹14,560", "₹5,180", "₹9,380", "₹6,81,310"],
          ["3", "₹14,560", "₹5,110", "₹9,450", "₹6,71,860"],
          ["4", "₹14,560", "₹5,038", "₹9,522", "₹6,62,338"],
          ["5", "₹14,560", "₹4,967", "₹9,593", "₹6,52,745"],
          ["6", "₹14,560", "₹4,895", "₹9,665", "₹6,43,080"],
          ["7", "₹14,560", "₹4,823", "₹9,737", "₹6,33,343"],
          ["8", "₹14,560", "₹4,750", "₹9,810", "₹6,23,533"],
          ["9", "₹14,560", "₹4,676", "₹9,884", "₹6,13,649"],
          ["10", "₹14,560", "₹4,602", "₹9,958", "₹6,03,691"],
          ["11", "₹14,560", "₹4,528", "₹10,032", "₹5,93,659"],
          ["12", "₹14,560", "₹4,452", "₹10,108", "₹5,83,551"]
     
        ].map(([month, emi, interest, principal, balance], index) => (
          <tr key={index}>
            <td className="border px-4 py-2">{month}</td>
            <td className="border px-4 py-2">{emi}</td>
            <td className="border px-4 py-2">{interest}</td>
            <td className="border px-4 py-2">{principal}</td>
            <td className="border px-4 py-2">{balance}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Card layout for small screens */}
  <div className="md:hidden space-y-4 mt-4">
    {[
           ["1", "₹14,560", "₹5,250", "₹9,310", "₹6,90,690"],
           ["2", "₹14,560", "₹5,180", "₹9,380", "₹6,81,310"],
           ["3", "₹14,560", "₹5,110", "₹9,450", "₹6,71,860"],
           ["4", "₹14,560", "₹5,038", "₹9,522", "₹6,62,338"],
           ["5", "₹14,560", "₹4,967", "₹9,593", "₹6,52,745"],
           ["6", "₹14,560", "₹4,895", "₹9,665", "₹6,43,080"],
           ["7", "₹14,560", "₹4,823", "₹9,737", "₹6,33,343"],
           ["8", "₹14,560", "₹4,750", "₹9,810", "₹6,23,533"],
           ["9", "₹14,560", "₹4,676", "₹9,884", "₹6,13,649"],
           ["10", "₹14,560", "₹4,602", "₹9,958", "₹6,03,691"],
           ["11", "₹14,560", "₹4,528", "₹10,032", "₹5,93,659"],
           ["12", "₹14,560", "₹4,452", "₹10,108", "₹5,83,551"]
    ].map(([month, emi, interest, principal, balance], index) => (
      <div key={index} className="bg-white shadow rounded-xl p-4 text-sm text-gray-700 space-y-1 border">
        <div><span className="font-semibold">Month:</span> {month}</div>
        <div><span className="font-semibold">EMI  (₹):</span> {emi}</div>
        <div><span className="font-semibold">Interest  (₹):</span> {interest}</div>
        <div><span className="font-semibold">Principal  (₹):</span> {principal}</div>
        <div><span className="font-semibold"> Outstanding(₹):</span> {balance}</div>
      </div>
    ))}
  </div>
</div>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This schedule helps borrowers understand the repayment journey and plan for prepayments or foreclosures accordingly.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Factors Affecting Your Car Loan EMI
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Several variables can impact your EMI amount when you take a PNB car loan. Understanding these factors can help you choose the most optimal loan offer and better manage your monthly finances.
            </p>
            <ul className="list-decimal pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Loan Amount</strong><br />
                A higher principal leads to higher EMIs. Always borrow according to your repayment capability.
              </li>
              <li><strong>Interest Rate</strong><br />
                The rate offered by PNB plays a critical role. Even a small difference in rate can make a significant impact over long tenures.
              </li>
              <li><strong>Loan Tenure</strong><br />
                A longer tenure reduces your monthly EMI but increases total interest outgo. A shorter tenure results in higher EMIs but lower interest payments.
              </li>
              <li><strong>Credit Score</strong><br />
                A strong credit score (750+) often helps in negotiating a better interest rate, thus reducing EMI.
              </li>
              <li><strong>Down Payment</strong><br />
                Making a higher down payment lowers your loan amount and EMI accordingly.
              </li>
              <li><strong>Type of Car and Insurance Premiums</strong><br />
                Some banks consider the car model and its insurance premium while determining EMI eligibility, especially in bundled offers.
              </li>
              <li><strong>Income and Employment Status</strong><br />
                Your monthly income, job stability, and employer profile can affect both your loan approval and applicable interest rate.
              </li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Understanding these factors can help you optimize your car loan EMI and avoid unexpected costs.
            </p>
          </div>
        </div>

     <div className="w-full md:w-1/3 p-4">
       <div className="bg-white shadow-md rounded-lg overflow-hidden">
         <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
           <h2 className="text-lg font-semibold ">Popular Categories</h2>
         </div>
         <div className="p-2 ">
         <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
             {/* {moreCategories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
           </ul>
         </div>
       </div>

     </div>

   </div>
   </div>
   <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                <h1 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h1>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
   </>
  );
};

export default UninonBankCarLoanEmiCalculator ;
